export default __webpack_public_path__ + "static/media/logo.cd5b480d.webp";